import React from "react"

import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
} from "reactstrap"

import "./modal.scss"

const ModalComponent = ({
  header,
  body,
  size,
  toggle,
  open,
  onSubmit,
  save,
}) => {
  return (
    <Modal isOpen={open} size={size} scrollable={true}>
      <ModalHeader tag="h5" toggle={toggle}>
        {header}
      </ModalHeader>
      <ModalBody className="pb-0">
        <Form onSubmit={onSubmit}>
          <FormGroup>
            {body}
            {!save && (
              <div className="d-flex mt-4 gap-3">
                <Button className="ms-auto" color="primary" type="submit">
                  Guardar
                </Button>
                <Button color="light" onClick={toggle}>
                  Cerrar
                </Button>
              </div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default ModalComponent
